import { GetterTree } from 'vuex';
import { AuthState } from './types';
import { RootState } from '../../types';
import {
  vmeSingleCompanyAdminGroup,
  vmeGlobalAdminGroup,
  vmeGlobalAdminGroupId,
  vmeSupportGroup,
  vmeSupportGroupId,
  vmeSingleCompanyAdminGroupId,
  vmePortalUserGroupId,
} from '@/shared/backend/account';
import GeneralUtils from '@/shared/utils/generalUtils';
import { CONST } from '@/shared/utils/Constants';
import router from '@/router';
import AuthUtils from '@/shared/utils/authUtils';

export const getters: GetterTree<AuthState, RootState> = {
  /**
   * Answers whether the user is authenticated (an access token is provided).
   */
  // return a function so it is no cached
  ['token']: (state: AuthState) => () => state.token,
  /**
   * Answers the details of the current employee.
   */
  ['user']: (state: AuthState) => state.account,
  ['azureUser']: (state: AuthState) => state.azureData,
  ['azureUserEmail']: (state: AuthState, getters: any) => {
    // return GeneralUtils.getObjProperty(router.currentRoute.query, CONST.emailUrlParam)
    // console.log('azure state :>> ', state);
    // console.log('state.azureUser?.idTokenClaims?.preferred_username :>> ', getters.azureUser);
    return (
      state.azureData?.idTokenClaims?.preferred_username ||
      GeneralUtils.getObjProperty(router.currentRoute.query, CONST.emailUrlParam)
    );
  },
 ['contactType']: (state: AuthState) => 'member',
  ['isUserInAzureAdminGroup']: (state: AuthState) => state.isUserInAzureAdminGroup,
  ['isUserSupportOrSuperAdmin']: (state: AuthState) => {
    // return !!(
    //   state.userAdminGroups.find((x) => x.displayName == vmeSupportGroup) ||
    //   state.userAdminGroups.find((x) => x.displayName == vmeGlobalAdminGroup)
    // );
    return !!(
      state.userAdminGroups.find((x) => [vmeSupportGroup, vmeGlobalAdminGroup].includes(x.displayName)) ||
      // (AD-62) Use Azure GUID for filtering (displayName is `null` in production for some reason)
      state.userAdminGroups.find((x) => [vmeSupportGroupId, vmeGlobalAdminGroupId].includes(x.id))
    );
  },
  ['isUserSuperAdmin']: (state: AuthState) => {
    return !!(
      state.userAdminGroups.find((x) => x.displayName == vmeGlobalAdminGroup) ||
      // (AD-62) Use Azure GUID for filtering (displayName is `null` in production for some reason)
      state.userAdminGroups.find((x) => x.id == vmeGlobalAdminGroupId)
    );
  },

  isLoggedIn(state): boolean {
    return null != state.account && state.account.id! != '';
  },
  getUser(state): any {
    return state.account;
  },
  getUserId(state): string | null {
    return state.account ? state.account.id! : null;
  },
  getAccountId(state): string | null {
    return state.accountId ? state.accountId! : null;
  },
  isEmailConfirmed(state): boolean {
    return state.account ? state.account.emailConfirmed : false;
  },
  getEnvironment(state): string {
    return state.environment;
  },

  isAdmin(state): boolean {
    return !!state.account && state.account!.authorities && state.account!.authorities!.includes('ADMIN');
  },
  isManager(state): boolean {
    return !!state.account && state.account!.authorities && state.account!.authorities!.includes('MANAGER');
  },

  ['isProductionEnv']: (state: AuthState, getters: any): boolean => {
    console.log('--------------------isProductionEnv----------------------------------------  ===>>>   ',getters);
    console.log("store.getters['auth/environment']?.toLowerCase() :>> ", getters.environment?.toLowerCase());
    return (
      getters.environment &&
      (['production'].includes(getters.environment?.toLowerCase()) ||
        getters.environment.toLowerCase().includes('prod'))
    );
  },
  ['isUserGsUser']: (state: AuthState, getters) => {
    return !!(
      state.userAdminGroups.find((x) => [vmeSingleCompanyAdminGroup, vmePortalUserGroupId].includes(x.displayName)) ||
      // Use Azure GUID for filtering (displayName is `null` in production for some reason)
      state.userAdminGroups.find((x) => [vmeSingleCompanyAdminGroupId, vmePortalUserGroupId].includes(x.id)) ||
      (GeneralUtils.isLocalDevEnv() && AuthUtils.isForceOnlyGsUser)
    );
  },
  ['zrNummer']: (state: AuthState) => state.zrNummer,
  isUserOnlyGs(state, getters: any): boolean {
    return getters.isUserGsUser && !getters.isUserInAzureAdminGroup;
  },
  ['isInitialRedirect']: (state: AuthState) => state.isInitialRedirect,  
};
